import { add as _add, getAsync as _getAsync, getList as _getList, update as _update, deleteAll as _deleteAll } from "../../api";

const BASE_URL = "/settings/products";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "name",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 5,
};

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export async function getAllAsync() {
    return _getAsync({ url: BASE_URL });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}